<template>
  <div
    class="navigation__loader"
    v-if="loading || error"
  >
    <LoadingIndicator />
  </div>
  <div
    class="navigation-news"
    v-if="!loading && !error"
  >
    <div class="navigation-news__filters">
      <div class="navigation-news__filters-title">Filter by</div>
      <button
        class="navigation-news__filter-button"
        :class="{
          'navigation-news__filter-button--active': category === activeCategory,
        }"
        v-for="(category, index) in categories"
        :key="index"
        @click="toggleCategory(index)"
      >
        {{ category.title }}
      </button>
    </div>
    <div
      class="navigation-news__results"
      v-if="activeArticles && activeArticles.length > 0"
    >
      <div class="navigation-news__result-section">
        <template v-for="(article, lIndex) in activeArticles">
          <a
            class="navigation-news__result"
            :href="article.url"
            :key="lIndex"
            v-if="lIndex < 3"
          >
            <div class="navigation-news__result-meta">
              <span>{{ article.published }}</span>
              <span>{{ article.category }}</span>
            </div>
            <div class="navigation-news__result-title">{{ article.title }}</div>
          </a>
        </template>
      </div>
      <div class="navigation-news__result-section">
        <template v-for="(article, rIndex) in activeArticles">
          <a
            class="navigation-news__result"
            :href="article.url"
            :key="rIndex"
            v-if="rIndex > 2 && rIndex < 6"
          >
            <div class="navigation-news__result-meta">
              <span>{{ article.published }}</span>
              <span>{{ article.category }}</span>
            </div>
            <div class="navigation-news__result-title">{{ article.title }}</div>
          </a>
        </template>
      </div>
    </div>
    <div
      class="navigation-news__view-all"
      v-if="activeCategory"
    >
      <a
        :href="activeCategory.url"
        class="button navigation-news__view-all-button"
      >
        View All {{ activeCategory.title }}
      </a>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import LoadingIndicator from "../../components/Global/LoadingIndicator.vue";

export default {
  components: {
    LoadingIndicator,
  },
  data() {
    return {
      error: false,
      loading: true,
      news: [],
      categories: [],
      activeCategory: null,
      activeArticles: [],
    };
  },
  mounted() {
    this.getNews();
  },
  methods: {
    toggleCategory: function (key) {
      this.activeCategory = this.categories[key];
      this.activeArticles = this.activeCategory.articles;
    },
    getNews: async function () {
      axios
        .post(
          "/api/news" + `?skip=0&take=30`,
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.categories = response.data.categories;
          this.activeCategory = this.categories[0];
          this.activeArticles = this.activeCategory.articles;
          this.loading = false;
        })
        .catch((err) => {
          this.error = true;
          this.loading = false;
        });
    },
  },
};
</script>
